import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-transfer",
  "use": "icon-transfer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-transfer\">\n  <path d=\"M4 7h12.5M13.5 4 17 7l-3.5 3M20 17H7.5M10.5 14 7 17l3.5 3\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  <path d=\"M5 11.5h6M13 12.5h6\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" opacity=\".7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol